import { api, endpoints } from "api/api";
import { AxiosPromise } from "axios";
import { SmtpSettingsValues } from "pages/Settings/SmtpSettingsForm";
import { SmsSettingsValues } from "pages/Settings/SmsSettingsForm";
import { AutopaySettingsValues } from "pages/Settings/AutopaySettingsForm";
import { InvoiceSellerSettingsValues } from "pages/Settings/InvoiceSellerSettingsForm";
import { TrainerZoneAdminNotificationEmailValues } from "pages/Settings/TrainerZoneAdminNotificationEmailForm";
import { ClientAppSettingsValues } from "pages/Settings/ClientAppSettingsForm";
import { InvoiceModeSettingsValues } from "pages/Settings/InvoiceModeSettingsForm";
import { DocumentsV2SettingsValues } from "pages/Settings/DocumentsV2SettingsForm";
import { AutopayRefundsSettingsValues } from "pages/Settings/AutopayRefundsSettingsForm";

const getSettingsList = (): AxiosPromise<SettingsListItem[]> => {
  return api.get<SettingsListItem[]>(endpoints.SETTINGS.GET);
};

const saveClientApp = (values: ClientAppSettingsValues): AxiosPromise => {
  return api.post(endpoints.SETTINGS.CLIENT_APP, values);
};

const saveSmtp = (values: SmtpSettingsValues): AxiosPromise => {
  return api.post(endpoints.SETTINGS.SMTP, values);
};

const saveSms = (values: SmsSettingsValues): AxiosPromise => {
  return api.post(endpoints.SETTINGS.SMS, values);
};

const saveAutopay = (values: AutopaySettingsValues): AxiosPromise => {
  return api.post(endpoints.SETTINGS.AUTOPAY, values);
};

const saveTrainerZoneAdminNotificationEmail = (values: TrainerZoneAdminNotificationEmailValues): AxiosPromise => {
  return api.post(endpoints.SETTINGS.TRAINER_ZONE_ADMIN_NOTIFICATION_EMAIL, values);
};

const saveInvoiceSeller = (values: InvoiceSellerSettingsValues): AxiosPromise => {
  return api.post(endpoints.SETTINGS.INVOICE_SELLER, values);
};

const saveInvoiceMode = (values: InvoiceModeSettingsValues): AxiosPromise => {
  return api.post(endpoints.SETTINGS.INVOICE_MODE, values);
};

const saveDocumentsV2 = (values: DocumentsV2SettingsValues): AxiosPromise => {
  return api.post(endpoints.SETTINGS.DOCUMENTS_V2, values);
};

const saveAutopayRefunds = (values: AutopayRefundsSettingsValues): AxiosPromise => {
  return api.post(endpoints.SETTINGS.AUTOPAY_REFUNDS, values);
};

export const settingsApi = {
  getSettingsList,
  saveClientApp,
  saveSmtp,
  saveSms,
  saveAutopay,
  saveTrainerZoneAdminNotificationEmail,
  saveInvoiceSeller,
  saveInvoiceMode,
  saveDocumentsV2,
  saveAutopayRefunds,
};

export interface SettingsListItem {
  name: string;
  // Always "" for secrets (smtp-password, sms-api-token, autopay-shared-key): use isSet for those.
  value: string;
  type: number;
  // Whether the setting holds a non-empty value, reported even when value is masked.
  isSet: boolean;
}
